import { IIFrameBrowserService } from "./IIFrameBrowserService";

export class IFrameBrowserService implements IIFrameBrowserService {
    private container: HTMLElement | null;
    private iframe: HTMLIFrameElement | null;

    constructor() {
        this.container = null;
        this.iframe = null;
    }

    initialize(divId: string) {
        this.container = document.getElementById(divId);
        if (!this.container) {
            throw new Error(`IFrameBrowser: no element with id "${divId}" found.`);
        }

        // Create the iframe
        const iframe = document.createElement('iframe');
        iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin'); // tighten security
        iframe.allow = "autoplay; fullscreen;";
        iframe.title = 'Embedded Content';

        this.container.appendChild(iframe);
        this.iframe = iframe;
        this.close();
    }

    openUrl(url: string) {
        if (!this.iframe || !this.container) {
            throw new Error('IFrameBrowser: you must call initialize() before openUrl().');
        }
        // Basic validation
        try {
            new URL(url);
        } catch {
            throw new Error(`IFrameBrowser: "${url}" is not a valid URL.`);
        }
        this.iframe.src = url;
        this.container.style.display = 'block'; // Ensure the iframe is visible
    }

    close() {
        if (!this.iframe || !this.container) {
            throw new Error('IFrameBrowser: you must call initialize() before close().');
        }
        this.iframe.src = ''; // Clear the iframe
        this.container.style.display = 'none'; // Hide the iframe
    }
}